export default __webpack_public_path__ + "static/media/card_front_name.d1f77e82.svg";